// extracted by mini-css-extract-plugin
export default {"root":"styles_root__RyLHh","dragging-over":"styles_dragging-over__S3BYU","draggingOver":"styles_dragging-over__S3BYU","color":"styles_color__ILI5h"};